import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-add-edit-lessions',
  templateUrl: './add-edit-lessions.component.html',
  styleUrls: ['./add-edit-lessions.component.css']
})
export class AddEditLessionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
